module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kSX1M"))).then(() => parcelRequire('d0iPb'));